import React from 'react';
import { CHART_CONFIG } from './chartTheme';

/**
 * ChartTooltip — Styled tooltip matching design tokens.
 * Used as the `content` prop for Recharts Tooltip component.
 */
export default function ChartTooltip({ active, payload, label, formatter, labelFormatter }) {
  if (!active || !payload || payload.length === 0) return null;

  const displayLabel = labelFormatter ? labelFormatter(label) : label;

  return (
    <div
      style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--neutral-200)',
        borderRadius: 3,
        padding: '10px 14px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        fontSize: CHART_CONFIG.fontSize,
        fontFamily: CHART_CONFIG.fontFamily,
        maxWidth: 240,
      }}
    >
      {displayLabel && (
        <p style={{
          margin: '0 0 6px 0',
          fontWeight: 600,
          color: 'var(--color-text-default)',
          fontSize: 13,
        }}>
          {displayLabel}
        </p>
      )}
      {payload.map((entry, idx) => {
        const value = formatter ? formatter(entry.value, entry.name) : entry.value;
        return (
          <div
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginTop: idx > 0 ? 4 : 0,
            }}
          >
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: entry.color,
                flexShrink: 0,
              }}
            />
            <span style={{ color: 'var(--color-text-muted)' }}>
              {entry.name}:
            </span>
            <span style={{ fontWeight: 600, color: 'var(--color-text-default)' }}>
              {value}
            </span>
          </div>
        );
      })}
    </div>
  );
}
